import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import cs from "./locales/cs.json";
import da from "./locales/da.json";
import de from "./locales/de.json";
import el from "./locales/el.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fi from "./locales/fi.json";
import fr from "./locales/fr.json";
import hu from "./locales/hu.json";
import it from "./locales/it.json";
import nl from "./locales/nl.json";
import pl from "./locales/pl.json";
import pt from "./locales/pt.json";
import ro from "./locales/ro.json";
import sv from "./locales/sv.json";
import { readProxyLocale } from "./utils/proxyLocale.js";

const WITHDRAWAL_INFORMAL_SALUTATION_LOCALES = new Set(["de", "fr"]);

export function proxyLocaleWithSalutation(informalSalutationEnabled) {
  const locale = readProxyLocale();
  if (informalSalutationEnabled && WITHDRAWAL_INFORMAL_SALUTATION_LOCALES.has(locale)) {
    return `${locale}-informal`;
  }

  return locale;
}

i18n.use(initReactI18next).init({
  resources: {
    cs: { translation: cs },
    da: { translation: da },
    de: { translation: de },
    "de-informal": { translation: de.informal },
    el: { translation: el },
    en: { translation: en },
    es: { translation: es },
    fi: { translation: fi },
    fr: { translation: fr },
    "fr-informal": { translation: fr.informal },
    hu: { translation: hu },
    it: { translation: it },
    nl: { translation: nl },
    pl: { translation: pl },
    pt: { translation: pt },
    ro: { translation: ro },
    sv: { translation: sv },
  },
  lng: proxyLocaleWithSalutation(false),
  fallbackLng: {
    "de-informal": ["de"],
    "fr-informal": ["fr"],
    default: ["de"],
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
